import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { read, store } from "Helpers/LocalStorage";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import { ReactSVG } from "react-svg";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { push } from "Helpers/History";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { readRefreshToken, storeToken } from "Helpers/Token";
import infoErrorIcon from "Assets/svg/icon/infoErrorIcon.svg";
import infoSuccessIcon from "Assets/svg/icon/infoSuccessIcon.svg";
import { useTranslation } from 'react-i18next';

function Callback() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [dataPay, setDataPay] = useState(false);

  const onPushInformationPanel = () =>
    push("/dashboard/payment/information-panel");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          OrderId: read("orderId"),
        };
        const responseInfo = await PaymentService.GetPaymentInfo(params);
        let err = StatusHandler(responseInfo);
        if (!err.isFail) {
          const dataInfo = responseInfo.data.Value;
          setDataPay(dataInfo);
          if (dataInfo.NotFound === true) {
            push("/");
          }
          if (dataInfo.Transfer === true && dataInfo.RetrivalRefNo !== null) {
            const params = {
              TokenKey: read("userKey"),
              TokenRef: readRefreshToken(),
            };
            const response = await PaymentService.GetRefreshToken(params);
            const { data } = response;
            if (data["StatusCode"] === 200) {
              storeToken(data.Value.Token, data.Value["RefreshToken"]);
            } else if (data["StatusCode"] === -2) {
              const project = read("project");
              const unitId = read("unitId");
              const userId = read("userId");
              localStorage.clear();
              store("project", project);
              store("unitId", unitId);
              store("userId", userId);
              push("/");
              window.location.reload();
            }
          }
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiPaper className="callback-page h-50 p-4 mt-4">
        <Grid container className="p-1 h-100">
          {dataPay.Transfer && dataPay.RetrivalRefNo !== null ? (
            <Grid className="px-2 text-center m-auto" item xs={6}>
              <Typography variant={"h6"} align="center">
                <div className="icon-section success">
                  <ReactSVG src={infoSuccessIcon} />
                </div>
                <strong className="bold text-lg-center mt-4">
                  {t('successfulPayment')}
                </strong>
                <Typography className="mt-2" variant={"body2"} align="left">
                  <p>
                      {`${t('referenceNo')} : `}
                      <strong className="mx-2">{dataPay?.RetrivalRefNo}</strong>
                  </p>
                </Typography>
                <Typography className="mt-2" variant={"body2"} align="left">
                  <p>
                      {`${t('issueTracking')} : `}
                      <strong className="mx-2">{dataPay?.SystemTraceNo}</strong>
                  </p>
                </Typography>
                <MuiButton
                  color="secondary"
                  type="submit"
                  onClick={onPushInformationPanel}
                  className="w-100 my-3 mt-4"
                  title={<Translator id="panel_information" />}
                />
              </Typography>
            </Grid>
          ) : (
            <Grid className="px-2 text-center m-auto" item xs={6}>
              <Typography variant={"body2"} align="center">
                <div className="icon-section error">
                  <ReactSVG src={infoErrorIcon} />
                </div>

                <strong className="bold text-lg-center mt-4">
                  {`${t('transaction_error')}`}
                </strong>
                <MuiButton
                  color="secondary"
                  type="submit"
                  onClick={onPushInformationPanel}
                  className="w-100 my-3 mt-4"
                  title={<Translator id="panel_information" />}
                />
              </Typography>
            </Grid>
          )}
        </Grid>
      </MuiPaper>
    </>
  );
}

export default Callback;
